export const CLASS_NAMES = {
  container: 'flex w-full h-full',
  content: 'w-full my-auto relative',
  footer: 'w-full flex flex-row justify-center bottom-0 absolute mb-16',
};
